// extracted by mini-css-extract-plugin
export default {"root":"prop-identifier-numbers_root__h+dW5","prop":"prop-identifier-numbers_prop__C05h4","placeHolderShimmer":"prop-identifier-numbers_placeHolderShimmer__P0qWu"};